/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * One optional plugin the agent left out of the applied set.
 */
export type AgentStateWithheldPlugin = {
  /**
   * Marketplace the plugin belongs to.
   */
  marketplace?: string | undefined;
  /**
   * Why it was withheld: user_disabled for a default-on plugin the user turned off, not_opted_in for an opt-in plugin the user has not turned on.
   */
  reason: string;
  /**
   * The plugin's slug.
   */
  slug: string;
};

/** @internal */
export type AgentStateWithheldPlugin$Outbound = {
  marketplace?: string | undefined;
  reason: string;
  slug: string;
};

/** @internal */
export const AgentStateWithheldPlugin$outboundSchema: z.ZodMiniType<
  AgentStateWithheldPlugin$Outbound,
  AgentStateWithheldPlugin
> = z.object({
  marketplace: z.optional(z.string()),
  reason: z.string(),
  slug: z.string(),
});

export function agentStateWithheldPluginToJSON(
  agentStateWithheldPlugin: AgentStateWithheldPlugin,
): string {
  return JSON.stringify(
    AgentStateWithheldPlugin$outboundSchema.parse(agentStateWithheldPlugin),
  );
}
